export const phoneNumberTypes = {
  USER_NUMBER: 'UserNumber',
  SYSTEM_NUMBER: 'SystemNumber',
  MARKETING_NUMBER: 'MarketingNumber',
  LOCAL_PRESENCE: 'LocalPresence',
};

export const CompanyType = {
  LENDER: 'Lender',
  BROKER: 'Broker',
  INTERNAL: 'Internal',
};

export const OrganizationType = {
  CORPORATION: 'Corporation',
  LIMITED_LIABILITY_COMPANY: 'LimitedLiabilityCompany',
  LIMITED_PARTNERSHIP: 'LimitedPartnership',
  LIMITED_LIABILITY_PARTNERSHIP: 'LimitedLiabilityPartnership',
  PARTNERSHIP: 'Partnership',
  FEDERAL_SAVINGS_BANK: 'FederalSavingsBank',
  STATE_SAVINGS_BANK: 'StateSavingsBank',
  SAVINGS_LOAN_ASSOSIATION: 'SavingsAndLoanAssociation',
  CREDIT_UNION: 'CreditUnion',
};

export const SubCompanyType = {
  BROKER: 'Broker',
  CORRESPONDENT: 'Correspondent',
  BRANCH: 'Branch',
};

export const PpeType = {
  LENDER_PPE: 'Lender',
  LENDER_V2_PPE: 'LenderV2',
  LOAN_SIFTER_PPE: 'LoanSifter',
  OPTIMAL_BLUE_PPE: 'OptimalBlue',
  OPTIMAL_BLUE_UI_PPE: 'OptimalBlueUi',
  NO_PPE: 'None',
};

export const LoanOptionVendorType = {
  LENDER: 'Lender',
  OPTIMAL_BLUE_LOAN_SIFTER: 'OptimalBlueLoanSifter',
  OPTIMAL_BLUE: 'OptimalBlue',
};

export const ContactsPresentationType = {
  APPLY_FORM: 'ApplyForm',
  REALTORS: 'Realtors',
};

export const mappingsTypes = {
  COMPANY_MAPPING: 'Company',
  LO_MAPPING: 'User',
};

export const FederalAgencyComplianceType = {
  CONSUMER_FINANCIAL_PROTECTION_BUREAU: 'ConsumerFinancialProtectionBureau',
  FEDERAL_DEPOSIT_INSURANCE_CORPORATION: 'FederalDepositInsuranceCorporation',
  NATIONAL_CREDIT_UNION_ADMINISTRATION: 'NationalCreditUnionAdministration',
  OFFICE_OF_THE_COMPTROLLER: 'OfficeOfTheComptroller',
};

export const LoanNumberSegmentType = {
  COMPANY_PREFIX: 'CompanyPrefix',
  YEAR: 'Year',
  SEQUENCE_COUNTER: 'SequenceCounter',
  STATIC_TEXT: 'StaticText',
};

export const LoanNumberResetBehavior = {
  RESET_EACH_YEAR: 'ResetEachYear',
  RUN_CONTINUOUSLY: 'RunContinuously',
};

export const HmdaFederalAgencyCode = {
  OCC: 'OCC',
  FRS: 'FRS',
  FDIC: 'FDIC',
  NCUA: 'NCUA',
  HUD: 'HUD',
  CFPB: 'CFPB',
};

export const mappingsOptions = [
  { label: 'Company Lender Mapping', value: mappingsTypes.COMPANY_MAPPING },
  { label: 'LO Lender Mapping', value: mappingsTypes.LO_MAPPING },
];
